import { render, staticRenderFns } from "./ButtonEditor.vue?vue&type=template&id=7afed212&scoped=true"
import script from "./ButtonEditor.vue?vue&type=script&lang=js"
export * from "./ButtonEditor.vue?vue&type=script&lang=js"
import style0 from "./ButtonEditor.vue?vue&type=style&index=0&id=7afed212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afed212",
  null
  
)

export default component.exports